import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {floorChoiceOptions, houseStoreysOptions, mapArea, mapBudget, mapFromFilterOptions, mapRooms} from "./amplitude_listing_filters_tracking_utils";

export type AmplitudeInvestmentListingFiltersTrigger = "automatic" | "manual";

export interface IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams {
    filterValues: ISearchFiltersFormValues;
    filterTrigger: AmplitudeInvestmentListingFiltersTrigger;
    itemListId: string;
}

export const getAmplitudeInvestmentListingFiltersAppliedEventProperties = ({
    filterValues,
    filterTrigger,
    itemListId
}: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    const budget = mapBudget(filterValues.price);
    const rooms = mapRooms(filterValues.rooms);
    const area = mapArea(filterValues.area);
    // floor_choices wins over house_storeys, but either one can be missing from a rehydrated form state (SRV-583),
    // so the normalization is left to mapFromFilterOptions instead of reading the raw values here
    const floor = mapFromFilterOptions(filterValues.floor_choices, floorChoiceOptions) ?? mapFromFilterOptions(filterValues.house_storeys, houseStoreysOptions);

    return {
        filter_trigger: filterTrigger,
        location: "investment_page",
        ...(budget ? {budget} : {}),
        ...(rooms ? {rooms} : {}),
        ...(area ? {area} : {}),
        ...(floor ? {floor} : {}),
        item_list_id: itemListId
    };
};
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {floorChoiceOptions, houseStoreysOptions, mapArea, mapBudget, mapFromFilterOptions, mapRooms} from "./amplitude_listing_filters_tracking_utils";

export type AmplitudeInvestmentListingFiltersTrigger = "automatic" | "manual";

export interface IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams {
    filterValues: ISearchFiltersFormValues;
    filterTrigger: AmplitudeInvestmentListingFiltersTrigger;
    itemListId: string;
}

export const getAmplitudeInvestmentListingFiltersAppliedEventProperties = ({
    filterValues,
    filterTrigger,
    itemListId
}: IGetAmplitudeInvestmentListingFiltersAppliedEventPropertiesParams) => {
    const budget = mapBudget(filterValues.price);
    const rooms = mapRooms(filterValues.rooms);
    const area = mapArea(filterValues.area);
    // floor_choices wins over house_storeys, but either one can be missing from a rehydrated form state (SRV-583),
    // so the normalization is left to mapFromFilterOptions instead of reading the raw values here
    const floor = mapFromFilterOptions(filterValues.floor_choices, floorChoiceOptions) ?? mapFromFilterOptions(filterValues.house_storeys, houseStoreysOptions);

    return {
        filter_trigger: filterTrigger,
        location: "investment_page",
        ...(budget ? {budget} : {}),
        ...(rooms ? {rooms} : {}),
        ...(area ? {area} : {}),
        ...(floor ? {floor} : {}),
        item_list_id: itemListId
    };
};
